/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useMemo, useState } from "react";
import {
  Table,
  Segment,
  Container,
  Grid,
  Header,
  Icon,
  Label,
  Message,
  Input,
  Button,
  Dropdown,
  Modal,
} from "semantic-ui-react";
import { db } from "../firebase/firebaseConfig";
import { getDocs, collection, where, query } from "firebase/firestore";
import { useContext } from "react";
import { UserContext } from "../context/UserContext";
import moment from "moment";
import ModalDetalle from "./Modal";
import { Contenido } from "../elementos/CrearEquipos";
import { Boton2 } from "../elementos/General";
import { PDFViewer } from "@react-pdf/renderer";

import DocumentoEntradaPDF from "./DocumentoEntradaPDF";
import DocumentoSalidaPDF from "./DocumentoSalidaPDF";

const stickyTh = {
  position: "sticky",
  top: 0,
  zIndex: 1,
  background: "#f9f9f9",
};

const ReporteMovimientos = () => {
  const { users } = useContext(UserContext);

  const [cabecera, setCabecera] = useState([]);
  const [cabeceraOut, setCabeceraOut] = useState([]);

  const [loadingCab, setLoadingCab] = useState(false);

  const [estadoModal, setEstadoModal] = useState(false);
  const [mostrarSt, setMostrarSt] = useState([]);
  const [loadingDetalle, setLoadingDetalle] = useState(false);
  const [detalleTipo, setDetalleTipo] = useState("");
  const [detalleAnulado, setDetalleAnulado] = useState(false);

  const [busqueda, setBusqueda] = useState("");
  const [quickRange, setQuickRange] = useState(30);
  const [desde, setDesde] = useState("");
  const [hasta, setHasta] = useState("");
  const [tipoFiltro, setTipoFiltro] = useState("ALL");
  const [ordenFecha, setOrdenFecha] = useState("DESC");

  const [modalPdf, setModalPdf] = useState(false);
  const [pdfCabecera, setPdfCabecera] = useState(null);
  const [pdfDetalle, setPdfDetalle] = useState([]);
  const [pdfTipo, setPdfTipo] = useState("");
  const [loadingPdf, setLoadingPdf] = useState(false);

  const [modalArchivo, setModalArchivo] = useState(false);
  const [urlArchivoModal, setUrlArchivoModal] = useState("");

  const formatearFecha = (fecha) => {
    if (!fecha?.toDate) return "";
    return moment(fecha.toDate()).format("DD/MM/YYYY HH:mm");
  };

  const toSearchText = (value) => {
    if (value === null || value === undefined) return "";
    if (value?.toDate) return moment(value.toDate()).format("DD/MM/YYYY HH:mm");
    if (Array.isArray(value)) return value.map(toSearchText).join(" ");

    if (typeof value === "object") {
      try {
        return JSON.stringify(value);
      } catch {
        return String(value);
      }
    }

    return String(value);
  };

  const getCabeceras = async () => {
    if (!users?.emp_id) return;

    setLoadingCab(true);

    try {
      const qIn = query(
        collection(db, "entradasCab"),
        where("emp_id", "==", users.emp_id)
      );

      const qOut = query(
        collection(db, "salidasCab"),
        where("emp_id", "==", users.emp_id)
      );

      const [snapIn, snapOut] = await Promise.all([
        getDocs(qIn),
        getDocs(qOut),
      ]);

      setCabecera(
        snapIn.docs.map((d) => ({
          ...d.data(),
          id: d.id,
        }))
      );

      setCabeceraOut(
        snapOut.docs.map((d) => ({
          ...d.data(),
          id: d.id,
        }))
      );
    } finally {
      setLoadingCab(false);
    }
  };

  useEffect(() => {
    getCabeceras();
  }, [users?.emp_id]);

  const mergeBase = useMemo(() => {
    return [...cabecera, ...cabeceraOut];
  }, [cabecera, cabeceraOut]);

  const rangoMs = useMemo(() => {
    if (desde || hasta) {
      const fromMs = desde
        ? moment(desde, "YYYY-MM-DD").startOf("day").valueOf()
        : Number.NEGATIVE_INFINITY;

      const toMs = hasta
        ? moment(hasta, "YYYY-MM-DD").endOf("day").valueOf()
        : Number.POSITIVE_INFINITY;

      return { fromMs, toMs };
    }

    if (!quickRange || quickRange === 0) {
      return {
        fromMs: Number.NEGATIVE_INFINITY,
        toMs: Number.POSITIVE_INFINITY,
      };
    }

    const toMs = moment().endOf("day").valueOf();
    const fromMs = moment().subtract(quickRange, "days").startOf("day").valueOf();

    return { fromMs, toMs };
  }, [desde, hasta, quickRange]);

  const getTipoDocES = (item) => {
    const tio = String(item?.tipoinout || "").toLowerCase();

    if (tio.includes("entrada")) return "ENTRADA";
    if (tio.includes("salida")) return "SALIDA";

    return item?.tipmov === 1 ? "ENTRADA" : "SALIDA";
  };

  const datosFiltrados = useMemo(() => {
    const q = (busqueda || "").trim().toLowerCase();

    let arr = mergeBase.filter((item) => {
      const ms = item?.date?.toMillis?.() ?? 0;
      return ms >= rangoMs.fromMs && ms <= rangoMs.toMs;
    });

    if (tipoFiltro !== "ALL") {
      arr = arr.filter((item) => getTipoDocES(item) === tipoFiltro);
    }

    if (q) {
      const keys = ["rut", "entidad", "tipdoc", "numdoc", "tipoinout", "tipmov"];

      arr = arr.filter((item) => {
        const hitKey = keys.some((k) =>
          toSearchText(item[k]).toLowerCase().includes(q)
        );

        if (hitKey) return true;

        return Object.keys(item).some((k) =>
          toSearchText(item[k]).toLowerCase().includes(q)
        );
      });
    }

    return [...arr].sort((a, b) => {
      const aMs = a?.date?.toMillis?.() ?? 0;
      const bMs = b?.date?.toMillis?.() ?? 0;

      return ordenFecha === "DESC" ? bMs - aMs : aMs - bMs;
    });
  }, [mergeBase, rangoMs, tipoFiltro, busqueda, ordenFecha]);

  const leerMovEntrada = async (cabId) => {
    const qIn = query(collection(db, "entradas"), where("cab_id", "==", cabId));
    const snap = await getDocs(qIn);

    return snap.docs.map((d) => ({
      ...d.data(),
      id: d.id,
    }));
  };

  const leerMovSalida = async (cabId) => {
    const qOut = query(collection(db, "salidas"), where("cab_id", "==", cabId));
    const snap = await getDocs(qOut);

    return snap.docs.map((d) => ({
      ...d.data(),
      id: d.id,
    }));
  };

  const abrirDetalle = async (item) => {
    setEstadoModal(true);
    setMostrarSt([]);
    setLoadingDetalle(true);

    const esEntrada = getTipoDocES(item) === "ENTRADA";

    setDetalleTipo(esEntrada ? "ENTRADA" : "SALIDA");
    setDetalleAnulado(item.tipmov === 3);

    try {
      const data = esEntrada
        ? await leerMovEntrada(item.id)
        : await leerMovSalida(item.id);

      setMostrarSt(data);
    } finally {
      setLoadingDetalle(false);
    }
  };

  const abrirPdf = async (item) => {
    const tipo = getTipoDocES(item);

    setModalPdf(true);
    setPdfCabecera(item);
    setPdfDetalle([]);
    setPdfTipo(tipo);
    setLoadingPdf(true);

    try {
      const detalle =
        tipo === "ENTRADA"
          ? await leerMovEntrada(item.id)
          : await leerMovSalida(item.id);

      setPdfDetalle(detalle);
    } finally {
      setLoadingPdf(false);
    }
  };

  const abrirAdjunto = (item) => {
    if (!item.urlAdjunto) return;

    setUrlArchivoModal(item.urlAdjunto);
    setModalArchivo(true);
  };

  const labelEstado = (tipmov) => {
    if (tipmov === 3) {
      return (
        <Label color="red" size="tiny">
          ANULADO
        </Label>
      );
    }

    return (
      <Label color="green" size="tiny">
        CONFIRMADO
      </Label>
    );
  };

  const labelTipoES = (item) => {
    const tipo = getTipoDocES(item);

    if (tipo === "ENTRADA") {
      return (
        <Label color="blue" size="tiny">
          ENTRADA
        </Label>
      );
    }

    if (tipo === "SALIDA") {
      return (
        <Label color="violet" size="tiny">
          SALIDA
        </Label>
      );
    }

    return (
      <Label basic size="tiny">
        -
      </Label>
    );
  };

  const limpiarFiltros = () => {
    setBusqueda("");
    setQuickRange(30);
    setDesde("");
    setHasta("");
    setTipoFiltro("ALL");
    setOrdenFecha("DESC");
  };

  const opcionesTipo = [
    { key: "ALL", text: "Todos", value: "ALL", icon: "list" },
    { key: "ENTRADA", text: "Entradas", value: "ENTRADA", icon: "sign-in" },
    { key: "SALIDA", text: "Salidas", value: "SALIDA", icon: "sign-out" },
  ];

  const opcionesOrden = [
    {
      key: "DESC",
      text: "Más reciente",
      value: "DESC",
      icon: "sort amount down",
    },
    {
      key: "ASC",
      text: "Más antiguo",
      value: "ASC",
      icon: "sort amount up",
    },
  ];

  const totalResultados = datosFiltrados.length;

  const totalEntradas = datosFiltrados.filter(
    (item) => getTipoDocES(item) === "ENTRADA"
  ).length;

  const totalSalidas = datosFiltrados.filter(
    (item) => getTipoDocES(item) === "SALIDA"
  ).length;

  return (
    <Container
      fluid
      style={{
        maxWidth: 1400,
        padding: "24px 28px",
        background: "#f8fafc",
        minHeight: "100vh",
      }}
    >
      {/* ====================================================== */}
      {/* CABECERA */}
      {/* ====================================================== */}

      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: 20,
          gap: 20,
          flexWrap: "wrap",
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: 14,
          }}
        >
          <div
            style={{
              color: "#0d9da5",
              fontSize: 34,
              lineHeight: 1,
            }}
          >
            <Icon name="exchange" />
          </div>

          <div>
            <Header
              as="h2"
              style={{
                margin: 0,
                color: "#172b4d",
                fontSize: 24,
                fontWeight: 700,
              }}
            >
              Listado de Movimientos
            </Header>

            <div
              style={{
                color: "#8793a5",
                fontSize: 13,
                marginTop: 3,
              }}
            >
              Consulta y trazabilidad de entradas, salidas y traspasos de equipos
            </div>
          </div>
        </div>

        <div
          style={{
            display: "flex",
            gap: 10,
          }}
        >
          <Button
            basic
            icon
            labelPosition="left"
            style={{
              borderRadius: 6,
              background: "#ffffff",
              color: "#42526e",
            }}
          >
            <Icon name="download" />
            Exportar
          </Button>
        </div>
      </div>

      {/* ====================================================== */}
      {/* KPI */}
      {/* ====================================================== */}

      <Grid stackable columns={3} style={{ marginBottom: 12 }}>
        {/* RESULTADOS */}

        <Grid.Column>
          <Segment
            style={{
              borderRadius: 8,
              border: "1px solid #e6e9ef",
              boxShadow: "0 2px 5px rgba(0,0,0,0.03)",
              minHeight: 92,
              display: "flex",
              alignItems: "center",
              padding: "18px 24px",
            }}
          >
            <div
              style={{
                width: 48,
                height: 48,
                borderRadius: 14,
                background: "#e5f7f7",
                color: "#0d9da5",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                marginRight: 20,
                fontSize: 20,
              }}
            >
              <Icon name="file alternate outline" style={{ margin: 0 }} />
            </div>

            <div>
              <div
                style={{
                  fontSize: 23,
                  fontWeight: 700,
                  color: "#0d9da5",
                  lineHeight: 1.1,
                }}
              >
                {totalResultados}
              </div>

              <div
                style={{
                  color: "#637083",
                  marginTop: 5,
                  fontSize: 13,
                }}
              >
                resultados
              </div>
            </div>
          </Segment>
        </Grid.Column>

        {/* SALIDAS */}

        <Grid.Column>
          <Segment
            style={{
              borderRadius: 8,
              border: "1px solid #e6e9ef",
              boxShadow: "0 2px 5px rgba(0,0,0,0.03)",
              minHeight: 92,
              display: "flex",
              alignItems: "center",
              padding: "18px 24px",
            }}
          >
            <div
              style={{
                width: 48,
                height: 48,
                borderRadius: 14,
                background: "#f2eaff",
                color: "#7145d6",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                marginRight: 20,
                fontSize: 20,
              }}
            >
              <Icon name="sign-out" style={{ margin: 0 }} />
            </div>

            <div>
              <div
                style={{
                  fontSize: 23,
                  fontWeight: 700,
                  color: "#7145d6",
                  lineHeight: 1.1,
                }}
              >
                {totalSalidas}
              </div>

              <div
                style={{
                  color: "#637083",
                  marginTop: 5,
                  fontSize: 13,
                }}
              >
                salidas
              </div>
            </div>
          </Segment>
        </Grid.Column>

        {/* ENTRADAS */}

        <Grid.Column>
          <Segment
            style={{
              borderRadius: 8,
              border: "1px solid #e6e9ef",
              boxShadow: "0 2px 5px rgba(0,0,0,0.03)",
              minHeight: 92,
              display: "flex",
              alignItems: "center",
              padding: "18px 24px",
            }}
          >
            <div
              style={{
                width: 48,
                height: 48,
                borderRadius: 14,
                background: "#e7f4fb",
                color: "#2185d0",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                marginRight: 20,
                fontSize: 20,
              }}
            >
              <Icon name="sign-in" style={{ margin: 0 }} />
            </div>

            <div>
              <div
                style={{
                  fontSize: 23,
                  fontWeight: 700,
                  color: "#2185d0",
                  lineHeight: 1.1,
                }}
              >
                {totalEntradas}
              </div>

              <div
                style={{
                  color: "#637083",
                  marginTop: 5,
                  fontSize: 13,
                }}
              >
                entradas
              </div>
            </div>
          </Segment>
        </Grid.Column>
      </Grid>

      {/* ====================================================== */}
      {/* FILTROS */}
      {/* ====================================================== */}

      <Segment
        style={{
          borderRadius: 8,
          border: "1px solid #e5e9ef",
          boxShadow: "0 2px 5px rgba(0,0,0,0.03)",
          padding: 0,
          marginBottom: 14,
        }}
      >
        {/* TITULO FILTROS */}

        <div
          style={{
            padding: "14px 18px",
            borderBottom: "1px solid #edf0f4",
            display: "flex",
            alignItems: "center",
            gap: 8,
            fontWeight: 600,
            color: "#253858",
          }}
        >
          <Icon name="search" />
          Filtros de búsqueda
        </div>

        <div style={{ padding: 16 }}>
          {/* FILA 1 */}

          <Grid stackable>
            <Grid.Row>
              <Grid.Column width={5}>
                <Input
                  fluid
                  icon="search"
                  iconPosition="left"
                  placeholder="Buscar por RUT, entidad, documento o número"
                  value={busqueda}
                  onChange={(e) => setBusqueda(e.target.value)}
                />
              </Grid.Column>

              <Grid.Column width={5}>
                <Dropdown
                  fluid
                  selection
                  options={opcionesTipo}
                  value={tipoFiltro}
                  onChange={(_, data) => setTipoFiltro(data.value)}
                  placeholder="Tipo de movimiento"
                />
              </Grid.Column>

              <Grid.Column width={6}>
                <Dropdown
                  fluid
                  selection
                  options={opcionesOrden}
                  value={ordenFecha}
                  onChange={(_, data) => setOrdenFecha(data.value)}
                  placeholder="Orden"
                />
              </Grid.Column>
            </Grid.Row>

            {/* FILA 2 */}

            <Grid.Row verticalAlign="middle">
              <Grid.Column width={5}>
                <Button.Group fluid>
                  <Button
                    basic={quickRange !== 7 || !!desde || !!hasta}
                    color="teal"
                    onClick={() => {
                      setQuickRange(7);
                      setDesde("");
                      setHasta("");
                    }}
                  >
                    7 días
                  </Button>

                  <Button
                    basic={quickRange !== 30 || !!desde || !!hasta}
                    color="teal"
                    onClick={() => {
                      setQuickRange(30);
                      setDesde("");
                      setHasta("");
                    }}
                  >
                    30 días
                  </Button>

                  <Button
                    basic={quickRange !== 90 || !!desde || !!hasta}
                    color="teal"
                    onClick={() => {
                      setQuickRange(90);
                      setDesde("");
                      setHasta("");
                    }}
                  >
                    90 días
                  </Button>

                  <Button
                    basic={quickRange !== 0 || !!desde || !!hasta}
                    color="teal"
                    onClick={() => {
                      setQuickRange(0);
                      setDesde("");
                      setHasta("");
                    }}
                  >
                    Todo
                  </Button>
                </Button.Group>
              </Grid.Column>

              <Grid.Column width={4}>
                <Input
                  fluid
                  type="date"
                  label={{ content: "Desde" }}
                  value={desde}
                  onChange={(e) => {
                    setDesde(e.target.value);
                    setQuickRange(null);
                  }}
                />
              </Grid.Column>

              <Grid.Column width={4}>
                <Input
                  fluid
                  type="date"
                  label={{ content: "Hasta" }}
                  value={hasta}
                  onChange={(e) => {
                    setHasta(e.target.value);
                    setQuickRange(null);
                  }}
                />
              </Grid.Column>

              <Grid.Column width={3}>
                <Button
                  basic
                  fluid
                  icon
                  labelPosition="left"
                  onClick={limpiarFiltros}
                  style={{
                    color: "#657184",
                  }}
                >
                  <Icon name="trash alternate outline" />
                  Limpiar
                </Button>
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </div>
      </Segment>

      {/* ====================================================== */}
      {/* MOVIMIENTOS */}
      {/* ====================================================== */}

      <Segment
        style={{
          borderRadius: 8,
          border: "1px solid #e5e9ef",
          boxShadow: "0 2px 5px rgba(0,0,0,0.03)",
          padding: 0,
          overflow: "hidden",
        }}
      >
        {/* HEADER TABLA */}

        <div
          style={{
            padding: "14px 18px",
            borderBottom: "1px solid #edf0f4",
            display: "flex",
            alignItems: "center",
            gap: 10,
          }}
        >
          <Icon
            name="file alternate outline"
            style={{ color: "#253858" }}
          />

          <span
            style={{
              fontWeight: 600,
              color: "#253858",
            }}
          >
            Movimientos registrados
          </span>

          <span
            style={{
              fontSize: 11,
              color: "#98a1af",
              marginLeft: 12,
            }}
          >
            {datosFiltrados.length} registros encontrados
          </span>
        </div>

        {/* TABLA */}

        <div
          style={{
            maxHeight: 520,
            overflow: "auto",
          }}
        >
          <Table
            celled
            compact
            selectable
            style={{
              margin: 0,
              border: 0,
              borderRadius: 0,
            }}
          >
            <Table.Header>
              <Table.Row>
                <Table.HeaderCell style={stickyTh}>
                  N°
                </Table.HeaderCell>

                <Table.HeaderCell style={stickyTh}>
                  Documento
                </Table.HeaderCell>

                <Table.HeaderCell style={stickyTh}>
                  Número
                </Table.HeaderCell>

                <Table.HeaderCell style={stickyTh}>
                  Fecha
                </Table.HeaderCell>

                <Table.HeaderCell style={stickyTh}>
                  Tipo E/S
                </Table.HeaderCell>

                <Table.HeaderCell style={stickyTh}>
                  Estado
                </Table.HeaderCell>

                <Table.HeaderCell style={stickyTh}>
                  RUT
                </Table.HeaderCell>

                <Table.HeaderCell style={stickyTh}>
                  Entidad
                </Table.HeaderCell>

                <Table.HeaderCell
                  style={stickyTh}
                  textAlign="center"
                >
                  Acciones
                </Table.HeaderCell>
              </Table.Row>
            </Table.Header>

            <Table.Body>
              {loadingCab && (
                <Table.Row>
                  <Table.Cell colSpan={9}>
                    <Message icon info style={{ margin: 0 }}>
                      <Icon name="spinner" loading />

                      <Message.Content>
                        <Message.Header>
                          Cargando movimientos…
                        </Message.Header>

                        Consultando cabeceras de entradas y salidas.
                      </Message.Content>
                    </Message>
                  </Table.Cell>
                </Table.Row>
              )}

              {!loadingCab &&
                datosFiltrados.map((item, index) => (
                  <Table.Row key={item.id ?? index}>
                    <Table.Cell>
                      {index + 1}
                    </Table.Cell>

                    <Table.Cell>
                      {item.tipdoc}
                    </Table.Cell>

                    <Table.Cell>
                      {item.numdoc}
                    </Table.Cell>

                    <Table.Cell>
                      {formatearFecha(item.date)}
                    </Table.Cell>

                    <Table.Cell>
                      {labelTipoES(item)}
                    </Table.Cell>

                    <Table.Cell>
                      {labelEstado(item.tipmov)}
                    </Table.Cell>

                    <Table.Cell>
                      {item.rut}
                    </Table.Cell>

                    <Table.Cell
                      style={{
                        whiteSpace: "normal",
                        wordWrap: "break-word",
                      }}
                    >
                      {item.entidad}
                    </Table.Cell>

                    {/* ACCIONES */}

                    <Table.Cell textAlign="center">
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          gap: 6,
                        }}
                      >
                        {/* DETALLE */}

                        <Button
                          basic
                          size="mini"
                          icon
                          title="Ver detalle"
                          onClick={() => abrirDetalle(item)}
                          style={{
                            color: "#2185d0",
                            border: "1px solid #2185d0",
                            background: "#ffffff",
                          }}
                        >
                          <Icon
                            name="eye"
                            style={{ margin: 0 ,color: "#2185d0"}}
                          />
                        </Button>

                        {/* PDF */}

                        <Button
                          basic
                          size="mini"
                          icon
                          title="Ver PDF"
                          onClick={() => abrirPdf(item)}
                          style={{
                            color: "#db5b67",
                            border: "1px solid #db5b67",
                            background: "#ffffff",
                          }}
                        >
                          <Icon
                            name="file pdf outline"
                            style={{ margin: 0, color: "#db5b67" }}
                          />
                        </Button>

                        {/* ADJUNTO */}

                        <Button
                          basic
                          size="mini"
                          icon
                          disabled={!item.urlAdjunto}
                          title={
                            item.urlAdjunto
                              ? "Ver adjunto"
                              : "Sin adjunto"
                          }
                          onClick={() => abrirAdjunto(item)}
                          style={{
                            color: item.urlAdjunto
                              ? "#607286"
                              : "#b8bec6",
                            borderColor: "#dde2e8",
                            background: "#ffffff",
                          }}
                        >
                          <Icon
                            name="linkify"
                            style={{ margin: 0 }}
                          />
                        </Button>
                      </div>
                    </Table.Cell>
                  </Table.Row>
                ))}

              {!loadingCab &&
                datosFiltrados.length === 0 && (
                  <Table.Row>
                    <Table.Cell colSpan={9}>
                      <Message
                        warning
                        icon
                        style={{
                          margin: 15,
                        }}
                      >
                        <Icon name="search" />

                        <Message.Content>
                          <Message.Header>
                            Sin resultados
                          </Message.Header>

                          No hay movimientos que coincidan con los
                          filtros actuales.
                        </Message.Content>
                      </Message>
                    </Table.Cell>
                  </Table.Row>
                )}
            </Table.Body>
          </Table>
        </div>

        {/* FOOTER */}

        {!loadingCab && datosFiltrados.length > 0 && (
          <div
            style={{
              padding: "13px 18px",
              borderTop: "1px solid #edf0f4",
              color: "#697586",
              fontSize: 12,
            }}
          >
            Mostrando {datosFiltrados.length} movimientos
          </div>
        )}
      </Segment>


      {/* MODAL DETALLE ANTIGUO */}
      <ModalDetalle estado={estadoModal} cambiarEstado={setEstadoModal}>
        <Contenido>
          <Grid stackable verticalAlign="middle" style={{ marginBottom: 10 }}>
            <Grid.Row columns={2}>
              <Grid.Column>
                <Header as="h3" style={{ margin: 0 }}>
                  <Icon name="list" />
                  Detalle {detalleTipo}
                </Header>
              </Grid.Column>

              <Grid.Column textAlign="right">
                {detalleAnulado ? (
                  <Label color="red">Documento Anulado</Label>
                ) : (
                  <Label color="green">Documento Confirmado</Label>
                )}
              </Grid.Column>
            </Grid.Row>
          </Grid>

          {loadingDetalle ? (
            <Message icon info>
              <Icon name="spinner" loading />
              <Message.Content>
                <Message.Header>Cargando detalle…</Message.Header>
                Obteniendo líneas del documento.
              </Message.Content>
            </Message>
          ) : mostrarSt.length > 0 ? (
            <>
              <div style={{ maxHeight: 420, overflow: "auto" }}>
                <Table celled compact striped selectable>
                  <Table.Header>
                    <Table.Row>
                      <Table.HeaderCell>N°</Table.HeaderCell>
                      <Table.HeaderCell>Nombre de equipo</Table.HeaderCell>
                      <Table.HeaderCell>N° Serie</Table.HeaderCell>
                      <Table.HeaderCell>Precio</Table.HeaderCell>
                    </Table.Row>
                  </Table.Header>

                  <Table.Body>
                    {mostrarSt.map((item, index) => (
                      <Table.Row key={item.id ?? index}>
                        <Table.Cell>{index + 1}</Table.Cell>
                        <Table.Cell style={{ whiteSpace: "normal", wordWrap: "break-word" }}>
                          {[item.tipo, item.marca, item.modelo]
                            .filter(Boolean)
                            .join(" - ")}
                        </Table.Cell>
                        <Table.Cell>{item.serie}</Table.Cell>
                        <Table.Cell>
                          {(Number(item.price) || 0).toLocaleString()}
                        </Table.Cell>
                      </Table.Row>
                    ))}
                  </Table.Body>
                </Table>
              </div>

              <Boton2 onClick={() => setEstadoModal(false)}>Aceptar</Boton2>
            </>
          ) : (
            <Message warning icon>
              <Icon name="exclamation triangle" />
              <Message.Content>
                <Message.Header>Sin líneas</Message.Header>
                {detalleAnulado
                  ? "El documento está anulado o no tiene detalle asociado."
                  : "No se encontraron movimientos asociados a este documento."}
              </Message.Content>
            </Message>
          )}
        </Contenido>
      </ModalDetalle>

      {/* MODAL PDF SEMANTIC UI */}
      <Modal
        open={modalPdf}
        onClose={() => setModalPdf(false)}
        closeIcon
        size="large"
        dimmer="blurring"
      >
        <Modal.Header>
          <Icon name="file pdf" />
          PDF {pdfTipo}
        </Modal.Header>

        <Modal.Content style={{ height: "85vh", padding: 0, background: "#666" }}>
          {loadingPdf || !pdfCabecera ? (
            <Message icon info style={{ margin: 20 }}>
              <Icon name="spinner" loading />
              <Message.Content>
                <Message.Header>Generando PDF…</Message.Header>
                Preparando documento.
              </Message.Content>
            </Message>
          ) : pdfTipo === "ENTRADA" ? (
            <PDFViewer style={{ width: "100%", height: "100%", border: "none" }}>
              <DocumentoEntradaPDF
                numDoc={pdfCabecera.numdoc}
                nomTipDoc={pdfCabecera.tipdoc}
                date={formatearFecha(pdfCabecera.date)}
                nomTipoIn={pdfCabecera.tipoinout}
                rut={pdfCabecera.rut}
                entidad={pdfCabecera.entidad}
                descripcion={pdfCabecera.descripcion}
                dataEntrada={pdfDetalle}
              />
            </PDFViewer>
          ) : (
            <PDFViewer style={{ width: "100%", height: "100%", border: "none" }}>
              <DocumentoSalidaPDF
                numDoc={pdfCabecera.numdoc}
                nomTipDoc={pdfCabecera.tipdoc}
                date={formatearFecha(pdfCabecera.date)}
                nomTipoOut={pdfCabecera.tipoinout}
                rut={pdfCabecera.rut}
                entidad={pdfCabecera.entidad}
                correo={pdfCabecera.correo}
                patente={pdfCabecera.patente}
                descripcion={pdfCabecera.descripcion}
                dataSalida={pdfDetalle}
              />
            </PDFViewer>
          )}
        </Modal.Content>
      </Modal>

      {/* MODAL ADJUNTO SEMANTIC UI */}
      <Modal
        open={modalArchivo}
        onClose={() => setModalArchivo(false)}
        closeIcon
        size="large"
        dimmer="blurring"
      >
        <Modal.Header>
          <Icon name="paperclip" />
          Documento adjunto
        </Modal.Header>

        <Modal.Content style={{ height: "85vh", padding: 0, background: "#666" }}>
          <iframe
            src={urlArchivoModal}
            title="Documento adjunto"
            width="100%"
            height="100%"
            style={{
              border: "none",
              display: "block",
            }}
          />
        </Modal.Content>
      </Modal>
    </Container>
  );
};

export default ReporteMovimientos;